export * from './lib/notice-board-data-access.module';
export * as NoticeBoardSelectors from './lib/+state/notice-board.selectors';
export * as NoticeBoardActions from './lib/+state/notice-board.actions';
export { NoticeBoardService } from './lib/+state/notice-board.service';
